
import React from 'react';
import MultiItemInput from '../MultiItemInput';
import DocumentUpload from '../DocumentUpload';
import { DocumentsAndLinks, UploadedDocument } from '../../types';

interface DocumentsLinksFormProps {
  data: DocumentsAndLinks;
  onArrayChange: (field: string, value: string[]) => void;
  onDocumentUpload: (document: UploadedDocument) => void;
  onDocumentRemove: (documentId: string) => void;
}

const DocumentsLinksForm: React.FC<DocumentsLinksFormProps> = ({
  data,
  onArrayChange,
  onDocumentUpload,
  onDocumentRemove
}) => {
  return (
    <div className="animate-fade-in">
      <h3 className="text-lg font-medium mb-4">Key Documents & Links</h3>
      
      <MultiItemInput
        id="news_links"
        label="Relevant News Articles or Company Statements"
        placeholder="Enter URL and press Enter or Add"
        items={data.news_links}
        onChange={(items) => onArrayChange('news_links', items)}
      />
      
      <MultiItemInput
        id="reference_links"
        label="Links to Company Reports, SEC Filings, or Research"
        placeholder="Enter URL and press Enter or Add"
        items={data.reference_links}
        onChange={(items) => onArrayChange('reference_links', items)}
      />

      <DocumentUpload
        onDocumentUpload={onDocumentUpload}
        onDocumentRemove={onDocumentRemove}
        documents={data.uploaded_documents}
        className="mt-6"
      />
    </div>
  );
};

export default DocumentsLinksForm;
